import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import { styled, alpha } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Link, Route, useHistory, useLocation, Redirect } from "react-router-dom";
import shui_engine from '../../static/logo/logo_2.jpg'
import home from '../../static/image/home.png'
import library from '../../static/image/library.png'
import monitoring from '../../static/image/monitoring.png'
import people from '../../static/image/people.png'
import user_img from '../../static/image/user_img.png'
import mine_img from '../../static/image/mine_img.png'
import intelligent from '../../static/image/intelligent.png'



function TabbleLists(e) {
    const user_type = useSelector((state) => state.user.user_type);
    return (
        <div style={{ paddingBottom: 10 }}>
            <Link to='/largemodel' style={{ display: 'flex', alignItems: 'center',background: e.type==0?'rgb(221, 221, 221,0.6)':'#fff' }}>
                <div style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={home} alt='' style={{ width: 21, height: 21 }} />
                    </div>
                    <div style={{ paddingLeft: 15, color: '#000' }}>智能对话</div>
                </div>
            </Link>
            <Link to='/largemodel/knowledge_base' style={{ display: 'flex', alignItems: 'center' ,background: e.type==1?'rgb(221, 221, 221,0.6)':'#fff'}}>
                <div style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={library} alt='' style={{ width: 21, height: 21 }} />
                    </div>
                    <div style={{ paddingLeft: 15, color: '#000' }}>知识库</div>
                </div>
            </Link>
            <Link to='/largemodel/monitoring' style={{ display: 'flex', alignItems: 'center', padding: 10,background: e.type==2?'rgb(221, 221, 221,0.6)':'#fff' }}>
                <div style={{ display: 'flex', alignItems: 'center', paddingTop: 1 }}>
                    <img src={monitoring} alt='' style={{ width: 21, height: 22 }} />
                </div>
                <div style={{ paddingLeft: 15 }}>定时AI任务</div>
            </Link>
            <Link to='/largemodel/intelligent_agent' style={{ display: 'flex', alignItems: 'center', background: e.type==3?'rgb(221, 221, 221,0.6)':'#fff' }}>
                <div style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={intelligent} alt='' style={{ width: 21, height: 21 }} />
                    </div>
                    <div style={{ paddingLeft: 15, color: '#000' }}>智能体</div>
                </div>
            </Link>
            {
                user_type == 0 ? <Link to='/largemodel/people' style={{ display: 'flex', alignItems: 'center' ,background: e.type==4?'rgb(221, 221, 221,0.6)':'#fff'}}>
                    <div style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={people} alt='' style={{ width: 21, height: 21 }} />
                        </div>
                        <div style={{ paddingLeft: 15, color: '#000' }}>人员管理</div>
                    </div>
                </Link> : ('')
            }
            <Link to='/largemodel/mine' style={{ display: 'flex', alignItems: 'center', borderRadius: 5 ,background: e.type==5?'rgb(221, 221, 221,0.6)':'#fff'}}>
                <div style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={mine_img} alt='' style={{ width: 21, height: 21 }} />
                    </div>
                    <div style={{ paddingLeft: 15, color: '#000' }}>会员</div>
                </div>
            </Link>
        </div>
    )
}
export default TabbleLists